/**
 * Payors layout shell (US-028).
 *
 * Mirrors the brands layout pattern — the index and detail routes are
 * nested under this so we share the auth boundary.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/payors')({
  component: PayorsLayout,
});

function PayorsLayout() {
  return <Outlet />;
}
